export const QrScannerActiveMode = {
  customer: 'customer',
  staff: 'staff',
  dynamic: 'dynamic',
} as const

type QrScannerActiveMode =
  (typeof QrScannerActiveMode)[keyof typeof QrScannerActiveMode]

export type QrScannerMode = QrScannerActiveMode | 'disabled'

export const parseQrCode = (data: string, mode: QrScannerMode) => {
  if (mode === 'disabled') {
    return null
  }

  return {
    mode,
    code: data,
  }
}

export type QrParserResult = ReturnType<typeof parseQrCode>
